import { batch, useSignal } from "@preact/signals-react"
import { useEffect } from "react"
import { isEmpty } from "@ui-seeker/utils"
import {analyzerChartVisibility, isAnalyzerLoading, responseData} from "Pages/AnalyzersV2/@signals"

export default function useAnalyzerData(resData) {
	const tableData = useSignal([])
	const pricesTableData = useSignal([])
	const tableColumns = useSignal([])
	const dataEmpty = useSignal(true)
	const evolutionData = useSignal({})
	const chartContent = useSignal({})
	const noResults = useSignal(false)
	const mainData = useSignal({})
	const marketChartData = useSignal([])

	useEffect(() => {
		dataEmpty.value = isEmpty(resData)
		batch(() => {
			noResults.value = resData.no_results
			tableData.value = resData.trows
			tableColumns.value = resData.xlist
			evolutionData.value = {
				columnKey: resData?.columnKey,
				rowKey: resData?.rowKey,
				rowValues: resData?.rowValues,
				evolutionColumnValues: resData?.evolutionColumnValues,
			}
			chartContent.value = {
				keySeries: resData?.keySeries,
				chartData: resData?.chartData,
				isDateAxis: false,
				sitesFilterOptions: resData?.siteOptions,
				officeData: resData?.officeData,
				executionDateTime: resData?.executionDateTime,

			}
			analyzerChartVisibility.value = resData.keySeries?.map(({ dataKey }) => dataKey)
			pricesTableData.value = resData?.tablePriceSortedByCategory
			mainData.value = resData?.mainData || {}
			marketChartData.value = resData?.charDataMarket || []
		})
	}, [isAnalyzerLoading.value, JSON.stringify(responseData.value)])

	return {
		tableData: tableData.value,
		tableColumns: tableColumns.value,
		dataEmpty: dataEmpty.value,
		evolutionData: evolutionData.value,
		chartContent: chartContent.value,
		noResults: noResults.value,
		pricesTableData: pricesTableData.value,
		mainData: mainData.value,
		marketChartData: marketChartData.value
	}

}